<template>
    <div class="fcsdOrpls">
        <div class="tit">
            <img src="@/assets/common/titLogo.png"
                 alt="">
            <span>{{lotteryType == 2?'福彩3D':lotteryType == 3?'排列三':'' }}兵器库</span>
        </div>
        <div v-if="lotteryType == 2"
             class="cont">
            <div>
                <a target="_blank"
                   href="https://www.3533.com/pailie3/"><span>在线缩水</span></a>
                <a target="_blank"
                   href="https://www.3533.com/3d/fushi/"><span>复式全排列组号器</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://www.3533.com/3d/hezhi/"><span>和值全排列组号器</span></a>
                <!-- <a target="_blank" href="http://www.cwl.gov.cn/ygkj/kjzb/"><span>开奖直播</span></a> -->
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/lengre/#0"><span>冷热分析</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://www.3533.com/3d/daxiao/"><span>大小全排列组号器</span></a>
                <a target="_blank"
                   href="http://www.cwl.gov.cn/c/2023/10/15/556274.shtml"><span>开奖公告</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://www.3533.com/3d/jiou/"><span>奇偶全排列组号器</span></a>
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/haoma/#1,1,0"><span>号码走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="http://www.cwl.gov.cn/ygkj/wqkjgg/fc3d/"><span>往期开奖视频</span></a>
                <a target="_blank"
                   href="http://www.cwl.gov.cn/ygkj/wqkjgg/fc3d/"><span>历史开奖号码</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/luzhu/"><span>路珠分析</span></a>

                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/dingwei/#1,0,0,1,1,0"><span>定位走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/daxiao/#1,1"><span>大小走势图</span></a>
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/danshuang/#1,1"><span>单双走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/zhihe/#1,1"><span>质和走势图</span></a>
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/hezhi/#1,1"><span>和值走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/3d/kuadu/#1,1"><span>首尾跨度</span></a>
                <a target="_blank"
                   href="http://www.cwl.gov.cn/ygkj/wqkjgg/fc3d/"><span>往期开奖视频</span></a>
            </div>
        </div>
        <div v-if="lotteryType == 3"
             class="cont">
            <div>
                <a target="_blank"
                   href="https://www.3533.com/pailie3/"><span>在线缩水</span></a>
                <a target="_blank"
                   href="https://www.3533.com/pailie3/fushi/"><span>复式全排列组号器</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://www.3533.com/pailie3/hezhi/"><span>和值全排列组号器</span></a>
                <!-- <a target="_blank" href="https://www.lottery.gov.cn/splb/"><span>开奖直播</span></a> -->
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/lengre/#0"><span>冷热分析</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://www.3533.com/pailie3/daxiao/"><span>大小全排列组号器</span></a>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/"><span>开奖公告</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://www.3533.com/pailie3/jiou/"><span>奇偶全排列组号器</span></a>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/haoma/#1,1,0"><span>号码走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://www.lottery.gov.cn/xytc/index.html"><span>往期开奖视频</span></a>
                <a target="_blank"
                   href="https://www.lottery.gov.cn/kj/kjlb.html?pls"><span>历史开奖号码</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/luzhu/"><span>路珠分析</span></a>

                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/dingwei/#1,0,0,1,1,0"><span>定位走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/daxiao/#1,1"><span>大小走势图</span></a>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/danshuang/#1,1"><span>单双走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/zhihe/#1,1"><span>质和走势图</span></a>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/zhihe/#1,1"><span>和值走势图</span></a>
            </div>
            <div>
                <a target="_blank"
                   href="https://caipiao.ip138.com/pailie3/kuadu/#1,1"><span>首尾跨度</span></a>
                <a target="_blank"
                   href="https://www.lottery.gov.cn/xytc/index.html"><span>往期开奖视频</span></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['lotteryType'],
    data () {
        return {
            fontType: '',
        }
    },
    mounted () {
        this.fontType = this.lotteryType == 1 ? '双色球' :
            this.lotteryType == 2 ? '大乐透' :
                this.lotteryType == 3 ? '3D' :
                    this.lotteryType == 4 ? '排三' : '';
    },
    methods: {
        // wl_link(){
        //     open('https://www.78500.cn/tool/p3filter.html')
        // }
    }
};
</script>

<style lang="scss" scoped>
a {
    text-decoration: none;
    color: #222222;
}
.fcsdOrpls {
    .tit {
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        img {
            width: 20px;
            margin-right: 10px;
        }
    }
    .cont {
        padding: 0 10px;
        border: 1px solid rgba(0, 0, 0, 0.07);
        div {
            padding: 15px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid rgba(0, 0, 0, 0.07);

            a {
                position: relative;
				transition: transform 0.5s linear, font-weight 0.5s linear;

                &:hover {
                    transform: scale(1.2);
                    font-weight: bold;
                    // text-decoration: underline;
                    &::after {
                        width: 100%;
                        left: 0%;
                    }
                }
                &:not(:hover) {
                    transform: scale(1);
                    font-weight: inherit;

                    &::after {
                        width: 0%;
                        left: 50%;
                    }
                }

                &::after {
                    content: '';
                    display: block;
                    border-bottom: 3px solid #3072cd;
                    width: 0%;
                    position: absolute;
                    left: 50%;
                    bottom: -5px;
                    transition: width 0.5s linear, left 0.5s linear;
                }
            }
        }
    }
}
</style>